import React, { useState } from "react";
import styles from "./AssetsAssign.module.css";
import { PiSealCheck } from "react-icons/pi";
import { Modal, SubmitButton, TextComponent } from "../../../../components";
import { FaCirclePlus } from "react-icons/fa6";
import assetsAssignImg from "../../../../assets/images/car.png";
import { List } from "antd";
import carImg from "../../../../assets/images/staticImages/car1.png";
import EditAssets from "../../../Dealership/AssetsManagement/EditAsset/EditAsset";

const AssetsAssign = ({ assignAssetsModal, setAssignAssetsModal }) => {
  const [assetsSuccessModal, setAssetsSuccessModal] = useState(false);
  const [openEditAssetsModal, setOpenEditAssetsModal] = useState(false);
  const dummyAccess = [
    {
      id: 1,
      image: carImg,
      name: "Hyundai Tucson",
      modelNo: "4T1B11HK6MU123456",
    },
    {
      id: 2,
      image: carImg,
      name: "Hyundai Tucson",
      modelNo: "4T1B11HK6MU123456",
    },
    {
      id: 3,
      image: carImg,
      name: "Hyundai Tucson",
      modelNo: "4T1B11HK6MU123456",
    },
  ];
  return (
    <div className={styles.mainCont}>
      <Modal
        open={assignAssetsModal}
        onCancel={() => setAssignAssetsModal(false)}
        imageClass={styles.assignAssetsImgStyle}
        icon={
          <img
            src={assetsAssignImg}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        width={"600px"}
        twoButton
        okBtnTitle={"Add new vehicle"}
        cancelBtnTitle={"Go Back"}
        leftBtnIcon={
          <FaCirclePlus
            size={15}
            color="var(--white-color)"
            style={{ marginRight: "5px" }}
          />
        }
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setAssignAssetsModal(false);
        }}
        onClickOkButton={() => {
          setAssignAssetsModal(false);
          setOpenEditAssetsModal(true);
        }}
        headingClass={styles.modalHeading}
      >
        <>
          <TextComponent
            text={"Assign Asset"}
            style={{
              fontFamily: "Urbanist-bold",
              fontSize: "var(--heading2-font-size)",
            }}
          />
          <div className={styles.assetsCont}>
            <List
              dataSource={dummyAccess}
              renderItem={(item, index) => (
                <div className={styles.assetslistItem} key={index}>
                  <div className={styles.assetsImgDiv}>
                    <img src={item?.image} />
                    <div className={styles.assetslistText}>
                      <TextComponent
                        text={item?.name}
                        style={{
                          fontFamily: "Urbanist-bold",
                          fontSize: "var(--dashboard_tabs-font-size)",
                        }}
                      />
                      <TextComponent text={`VIN ${item?.modelNo}`} />
                    </div>
                  </div>
                  <SubmitButton
                    secondaryBtn
                    title={"Assign"}
                    style={{ marginTop: "10px" }}
                    onClick={() => {
                      setAssetsSuccessModal(true);
                      setAssignAssetsModal(false);
                    }}
                  />
                </div>
              )}
            />
          </div>
        </>
      </Modal>

      {/* /////////////////////////Asset Assigned Successfull///////////////////////// */}
      <Modal
        open={assetsSuccessModal}
        onCancel={() => setAssetsSuccessModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Asset Assigned successfully"}
        width={"400px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setAssetsSuccessModal(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>
      <EditAssets
        isOpen={openEditAssetsModal}
        setIsOpen={setOpenEditAssetsModal}
      />
    </div>
  );
};

export default AssetsAssign;
